module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrese1e"
    }
  }, [_vm._v("\n  E-Learning\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f1cf808!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrese1e/component.vue
// module id = 3559
// module chunks = 1